import { useForm } from "@mantine/form";
import React from "react";
import { showNotification } from "@mantine/notifications";
import useSubmitApplication from "@lib/hooks/jobs/useSubmitApplication";
import { Check } from "react-feather";
import { trackEvent } from "../../Various/Analytics/gtag";

export type ApplicationFormStatus = {
  isSubmitting: boolean;
  isSuccess: boolean;
  errorMessage: string | null;
};

export default function useApplicationForm(jobId: string, close: () => void) {
  const form = useForm({
    initialValues: {
      email: "",
      name: "",
      linkedIn: "",
    },

    validate: {
      email: (value) =>
        /^\S+@\S+$/.test(value) ? null : "Ungültige E-Mail-Adresse",
      name: (value) =>
        value.length > 0 ? null : "Bitte geben Sie Ihren Namen ein",
    },
  });
  const [file, setFile] = React.useState<File>();
  const [fileError, setFileError] = React.useState<boolean>(false);

  const [status, setStatus] = React.useState<ApplicationFormStatus>({
    isSubmitting: false,
    isSuccess: false,
    errorMessage: null,
  });
  const submitApplication = useSubmitApplication(jobId);

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFileError(false);
    setStatus({
      isSubmitting: true,
      isSuccess: false,
      errorMessage: null,
    });

    if (!file) {
      setFileError(true);
      return;
    }

    form.onSubmit((values) => {
      submitApplication(
        {
          ...values,
          file,
        },
        (error) => {
          setStatus({
            isSubmitting: false,
            isSuccess: error == null,
            errorMessage: error,
          });

          if (error == null) {
            showNotification({
              id: "application-status",
              icon: <Check size={14} />,
              title: "Bewerbung erfolgreich gesendet",
              color: "green",
              message:
                "Vielen Dank für Ihre Bewerbung. Ihre Bewerbung wurde an das Unternehmen weitergeleitet, die weitere Kommunikation findet über Ihre angegeben Kontaktdaten statt.",
            });
            close();

            trackEvent({
              action: "submit_application",
              category: "job",
              label: jobId,
            });
          } else {
            trackEvent({
              action: "submit_application_error",
              category: "job",
              label: jobId,
            });
          }
        }
      );
    })(e);
  };

  return { form, file, setFile, submit, fileError, status };
}
